import { jsx, jsxs } from "react/jsx-runtime";
import { Box, ButtonChip, Flex, Text } from "pcln-design-system";
import { useState } from "react";
import analytics from "../../analytics/analytics.js";
const ButtonChipsAction = (props)=>{
    const { submitButtonChipActionMessage, hasOtherMessage, buttonChipsActions, isSeparatorMsg } = props;
    const [isButtonChipsActionsDisplayed, setButtonChipsActionsDisplayedValue] = useState(true);
    if (!isSeparatorMsg && (!buttonChipsActions.length || hasOtherMessage || !isButtonChipsActionsDisplayed)) return null;
    return /*#__PURE__*/ jsx(Box, {
        p: 2,
        overflow: 'auto',
        width: 1,
        display: 'inline-flex',
        children: buttonChipsActions.map((action, i)=>/*#__PURE__*/ jsx(Flex, {
                my: 2,
                mx: 0,
                alignItems: "center",
                children: /*#__PURE__*/ jsx(ButtonChip, {
                    id: `buttonChip${i}`,
                    m: 1,
                    onClick: function() {
                        submitButtonChipActionMessage(action);
                        setButtonChipsActionsDisplayedValue(false);
                        analytics.log({
                            label: 'buttonChipActions',
                            message: 'BUTTON_CHIP_ACTION_BUTTON_CLICKED',
                            content: action.label
                        });
                    },
                    children: /*#__PURE__*/ jsxs(Box, {
                        px: 3,
                        py: 1,
                        children: [
                            /*#__PURE__*/ jsx(Text, {
                                textAlign: "center",
                                bold: true,
                                fontSize: 1,
                                children: `${action?.emoticon ?? ''} ${action.label}`
                            }),
                            /*#__PURE__*/ jsx(Text, {
                                textAlign: "center",
                                regular: true,
                                fontSize: 0,
                                children: action.description
                            })
                        ]
                    })
                })
            }, `button-chip-action-button-${i}`))
    });
};
export { ButtonChipsAction };
